// Meta Pixel (Facebook Pixel) Service

// Inicializar Meta Pixel
export const initMetaPixel = () => {
  const pixelId = process.env.REACT_APP_META_PIXEL_ID || '1604610694242922';
  
  if (!pixelId) {
    console.warn('Meta Pixel not initialized: Missing Pixel ID');
    return;
  }

  // Cargar el script de Meta Pixel
  /* eslint-disable */
  !function(f,b,e,v,n,t,s)
  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
  n.queue=[];t=b.createElement(e);t.async=!0;
  t.src=v;s=b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t,s)}(window, document,'script',
  'https://connect.facebook.net/en_US/fbevents.js');
  /* eslint-enable */

  window.fbq('init', pixelId);
  window.fbq('track', 'PageView');
  
  console.log('Meta Pixel initialized with ID:', pixelId);
};

// Track evento de conversión (Purchase/Lead)
export const trackPurchase = (bookingData) => {
  if (typeof window.fbq === 'function') {
    window.fbq('track', 'Purchase', {
      value: bookingData.totalPrice,
      currency: 'ARS',
      content_name: bookingData.vehicleName,
      content_type: 'product',
      content_ids: [bookingData.vehicleId],
      num_items: 1,
      // Datos adicionales
      booking_id: bookingData.bookingId,
      booking_code: bookingData.bookingCode,
      pickup_location: bookingData.pickupLocation,
      return_location: bookingData.returnLocation,
      pickup_date: bookingData.pickupDate,
      return_date: bookingData.returnDate
    });
    console.log('Meta Pixel: Purchase event tracked', bookingData);
  }
};

// Track evento de Lead (cuando alguien intenta reservar)
export const trackLead = (bookingData) => {
  if (typeof window.fbq === 'function') {
    window.fbq('track', 'Lead', {
      value: bookingData.totalPrice,
      currency: 'ARS',
      content_name: bookingData.vehicleName,
      content_category: 'Car Rental'
    });
    console.log('Meta Pixel: Lead event tracked');
  }
};

// Track evento de InitiateCheckout (cuando llega a la página de reserva)
export const trackInitiateCheckout = (vehicleData) => {
  if (typeof window.fbq === 'function') {
    window.fbq('track', 'InitiateCheckout', {
      value: vehicleData.price,
      currency: 'ARS',
      content_name: vehicleData.name,
      content_ids: [vehicleData.id],
      content_type: 'product',
      num_items: 1
    });
    console.log('Meta Pixel: InitiateCheckout event tracked');
  }
};

// Track evento de ViewContent (cuando ve un vehículo)
export const trackViewContent = (vehicleData) => {
  if (typeof window.fbq === 'function') {
    window.fbq('track', 'ViewContent', {
      value: vehicleData.price,
      currency: 'ARS',
      content_name: vehicleData.name,
      content_ids: [vehicleData.id],
      content_type: 'product'
    });
    console.log('Meta Pixel: ViewContent event tracked');
  }
};

// Track evento de Search (cuando busca vehículos)
export const trackSearch = (searchParams) => {
  if (typeof window.fbq === 'function') {
    window.fbq('track', 'Search', {
      search_string: `${searchParams.pickupLocation} - ${searchParams.returnLocation}`,
      content_category: 'Car Rental'
    });
    console.log('Meta Pixel: Search event tracked');
  }
};

export default {
  initMetaPixel,
  trackPurchase,
  trackLead,
  trackInitiateCheckout,
  trackViewContent,
  trackSearch
};
